import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DeviceUserRelated from "./DeviceUserRelated";

class FormCreateNewUserByRole extends Component {

    constructor() {
        super();

        this.state  = {
            deviceList:[],
            userName: '',
            firstName: '',
            lastName: '',
            telephone: '',
            email: '',
            companyName: '',
            lineApiToken: '',
            resellerNote: '',
            password: '',
            confirmPassword: '',
            isMonitoring: true,
            isViewPoi: true,
            isEditPoi: true,
            isViewHistory: true,
            isSendCommand: true,
            isViewReport: true,
            isSendDailyReport: false,
            isCreateSubDealer: false,
            isSendEmailAlertOverdue: false,
            isAutoDispermit: false,
            isViewTracking: true
        };
    }
    componentWillMount(){
        const { dataSelectRow, isShowEdit, sideBarName } = this.props;
        if (dataSelectRow && isShowEdit) {
            console.log('dataSelectRow componentWillMount:', dataSelectRow)

            this.setState({
                isSendDailyReport: dataSelectRow.is_send_daily_report,
                isCreateSubDealer: dataSelectRow.is_create_subdealer,
                isSendEmailAlertOverdue: sideBarName !== 'dealerInfo' && sideBarName !== 'adminInfo' ? dataSelectRow.is_send_email_alert_overdue : '',
                isAutoDispermit: sideBarName !== 'dealerInfo' && sideBarName !== 'adminInfo' ? dataSelectRow.is_auto_dispermit : '',
            })
            // check error when dataSelectRow not privileges
            if (Object.prototype.hasOwnProperty.call(dataSelectRow, 'privileges')) {
                this.setState({
                    isViewTracking: sideBarName === 'customerInfo' ? dataSelectRow.privileges.is_view_tracking : '',
                    isViewPoi: sideBarName === 'customerInfo' ? dataSelectRow.privileges.is_view_poi : '',
                    isEditPoi: sideBarName === 'customerInfo' ? dataSelectRow.privileges.is_edit_poi : '',
                    isViewHistory: sideBarName === 'customerInfo' ? dataSelectRow.privileges.is_view_history : '',
                    isSendCommand: sideBarName === 'customerInfo' ? dataSelectRow.privileges.is_send_command : '',
                    isViewReport: sideBarName === 'customerInfo' ? dataSelectRow.privileges.is_view_report : ''
                })
            }

        }
    }

    componentWillUnmount(){
        this.setState({
            deviceList: []
        })

    }

    onClose(){
        this.props.onClose();
    }

    onClickSubmit = () => {
        const { onSubmit, sideBarName, dataSelectRow } = this.props;
        // const { isErrorField } = this.state;
        let data = {};
        let isErrorField = false;
        const {
            userName,
            firstName,
            lastName,
            telephone,
            email,
            companyName,
            lineApiToken,
            resellerNote,
            password,
            confirmPassword,
            isSendEmailAlertOverdue,
            isAutoDispermit,
            isViewTracking,
            isViewPoi,
            isEditPoi,
            isViewHistory,
            isSendCommand,
            isViewReport,
            isSendDailyReport,
            isCreateSubDealer
        } = this.state;
        console.log('isViewPoi:', isViewPoi);
        console.log('isEditPoi:', isEditPoi);
        console.log('userName:', userName);
        const { isShowEdit } = this.props;
        if (userName && userName.length > 0) {
            data.userName = userName.trim();
            isErrorField = false;
        } else {
            isErrorField = true;
        }

        if (firstName && firstName.length > 0) {
            data.firstName = firstName.trim()
            isErrorField = false;
        } else {
            isErrorField = true;
        }

        if (lastName && lastName.length > 0) {
            data.lastName = lastName.trim()
            isErrorField = false;
        } else {
            isErrorField = true;
        }

        if (telephone && telephone.length > 0) {
            data.telephone = telephone.trim()
            isErrorField = false;
        } else {
            isErrorField = true;
        }

        if (email && email.length > 0) {
            data.email = email.trim()
            isErrorField = false;
        } else {
            isErrorField = true;
        }

        if (companyName && companyName.length > 0) {
            data.companyName = companyName.trim()
            isErrorField = false;
        } else {
            isErrorField = true;
        }

        if (lineApiToken && lineApiToken.length > 0 && sideBarName === 'dealerInfo') {
            data.lineApiToken = lineApiToken.trim();
        }

        if (resellerNote && resellerNote.length > 0 && sideBarName !== 'dealerInfo') {
            data.resellerNote = resellerNote.trim();
        }

        if (isShowEdit) {
            isErrorField = false;
        }

        if (sideBarName === 'dealerInfo') {
            if ((password && password.length > 0) && (password === confirmPassword)) {
                data.password = password.trim()
                isErrorField = false;
            } else {
                alert('กรุณากรอกรหัสและยืนยืนรหัสผ่านให้ตรงกัน')
                isErrorField = true;
            }
        }

        if (sideBarName !== 'dealerInfo' && !isShowEdit) {
            if ((password && password.length > 0) && (password === confirmPassword)) {
                data.password = password.trim()
                isErrorField = false;
            } else {
                alert('กรุณากรอกรหัสและยืนยืนรหัสผ่านให้ตรงกัน')
                isErrorField = true;
            }
        }

        data.isSendEmailAlertOverdue = isSendEmailAlertOverdue;
        data.isAutoDispermit = isAutoDispermit;
        data.isViewTracking = isViewTracking; //? isViewTracking : dataSelectRow.privileges.is_view_tracking;
        data.isViewPoi = isViewPoi; //? isViewPoi : dataSelectRow.privileges.is_view_poi;
        data.isEditPoi = isEditPoi; //? isEditPoi : dataSelectRow.privileges.is_edit_poi;
        data.isViewHistory = isViewHistory; //? isViewHistory : dataSelectRow.privileges.is_view_history;
        data.isSendCommand = isSendCommand; //? isSendCommand : dataSelectRow.privileges.is_send_command;
        data.isViewReport = isViewReport; //? isViewReport : dataSelectRow.privileges.is_view_report;
        if (sideBarName === 'dealerInfo') {
            data.isSendDailyReport = isSendDailyReport; // || dataSelectRow.is_send_daily_report;
            data.isCreateSubDealer = isCreateSubDealer; // || dataSelectRow.is_create_subdealer;
        }
        // console.log('data onSubmitData:', data);
        if (!isErrorField) {
            onSubmit(data);
        }
    }

    onClickBack = () => {
        const {onBack} = this.props;
        onBack();
    }

    render() {
        const {
            t,
            sideBarName,
            isShowEdit,
            labelName,
            dataSelectRow,
            user_name,
            user_id,
            token,
            isShowCreateNewDealer,
            history,
            userLevel,
            resetPassword
        } = this.props;
        console.log('userLevel:', userLevel);
        console.log('dataSelectRow:', dataSelectRow);
        let labelEdit = isShowEdit ? t('แก้ไข') : t('เพิ่ม');
        let userName = (dataSelectRow && dataSelectRow.login_name) || '';
        let firstName = (dataSelectRow && dataSelectRow.first_name) || '';
        let lasttName = (dataSelectRow && dataSelectRow.last_name) || '';
        let telephone = (dataSelectRow && dataSelectRow.tel_no) || '';
        let email = (dataSelectRow && dataSelectRow.email) || '';
        let lineApiToken = (dataSelectRow && dataSelectRow.line_api_token) || '';
        let companyName = (dataSelectRow && dataSelectRow.company_name) || '';
        let resellerNote = (dataSelectRow && dataSelectRow.reseller_note) || '';

        let isCreateSubDealer = (dataSelectRow && dataSelectRow.is_create_subdealer) || '';
        let isSendDailyReport = (dataSelectRow && dataSelectRow.is_send_daily_report) || '';

        let isAutoDispermit = false;
        let isSendEmailAlertOverdue = false;
        let isViewTracking = true;
        let isViewPoi = true;
        let isEditPoi = true;
        let isViewHistory = true;
        let isSendCommand = true;
        let isViewReport = true;
        if (sideBarName === 'customerInfo' && isShowEdit) {
            // console.log('dataSelectRow:', dataSelectRow);
            isAutoDispermit = (dataSelectRow && dataSelectRow.is_auto_dispermit) || false;
            isSendEmailAlertOverdue = (dataSelectRow && dataSelectRow.is_send_email_alert_overdue) || false;
            if (Object.prototype.hasOwnProperty.call(dataSelectRow, 'privileges')) {
                isViewTracking = (dataSelectRow && dataSelectRow.privileges.is_view_tracking) || false;
                isViewPoi = (dataSelectRow && dataSelectRow.privileges.is_view_poi) || false;
                isEditPoi = (dataSelectRow && dataSelectRow.privileges.is_edit_poi) || false;
                isViewHistory = (dataSelectRow && dataSelectRow.privileges.is_view_history) || false;
                isSendCommand = (dataSelectRow && dataSelectRow.privileges.is_send_command) || false;
                isViewReport = (dataSelectRow && dataSelectRow.privileges.is_view_report) || false;
            }
        }

        if (sideBarName === 'employeeInfo' && isShowEdit) {
            isAutoDispermit = (dataSelectRow && dataSelectRow.is_auto_dispermit) || '';
            isSendEmailAlertOverdue = (dataSelectRow && dataSelectRow.is_send_email_alert_overdue) || '';
        }

        return(
                <div className="container-fluid">
                <div className="card">
                    <div className="card-header">
                        <h5> <i class="fa fa-arrow-left" aria-hidden="true" style={{color: '#7386D5',cursor: 'pointer'}} onClick={this.onClickBack}></i> {t('รายการ')} {labelName}</h5>
                    </div>
                    <div className="card-body">
                        <h1 className="page-header">{labelEdit} {labelName}</h1>
                        <br />

                                <div className="form-group row">
                                    <label className="col-md-2 col-form-label">{t('ชื่อผู้ใช้งาน')}</label>
                                    <div className="col-md-10">
                                        <input
                                            className="form-control"
                                            type="text"
                                            id="userName"
                                            defaultValue={userName}
                                            onChange={(e) => this.setState({ userName: e.target.value })}
                                        />
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label htmlFor="example-text-input" className="col-md-2 col-form-label">{t('ชื่อ')}</label>
                                    <div className="col-md-10">
                                        <input
                                            className="form-control"
                                            type="text"
                                            id="firstName"
                                            defaultValue={firstName}
                                            onChange={(e) => this.setState({ firstName: e.target.value })}
                                        />
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label htmlFor="example-text-input" className="col-md-2 col-form-label">{t('นามสกุล')}</label>
                                    <div className="col-md-10">
                                        <input
                                            className="form-control"
                                            type="text"
                                            id="lastName"
                                            defaultValue={lasttName}
                                            onChange={(e) => this.setState({ lastName: e.target.value })}
                                        />
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label htmlFor="example-text-input" className="col-md-2 col-form-label">{t('เบอร์โทรศัพท์')}</label>
                                    <div className="col-md-10">
                                <textarea
                                    className="form-control"
                                    id="telephone"
                                    rows={3}
                                    defaultValue={telephone}
                                    onChange={(e) => this.setState({ telephone: e.target.value })}
                                />
                                        <span>{t('หากต้องการใส่หลายเบอร์ให้คั่นด้วย , (ลูกน้ำ)')}</span>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label htmlFor="example-text-input" className="col-md-2 col-form-label">{t('อีเมล์')}</label>
                                    <div className="col-md-10">
                                <textarea
                                    className="form-control"
                                    id="email"
                                    rows={3}
                                    defaultValue={email}
                                    onChange={(e) => this.setState({ email: e.target.value })}
                                />
                                        <span>{t('หากต้องการใส่หลายอีเมล์ให้คั่นด้วย , (ลูกน้ำ)')}</span>
                                    </div>
                                </div>

                                <div className="form-group row">
                                    <label htmlFor="example-text-input"
                                        className="col-md-2 col-form-label">{t('ชื่อบริษัท')}</label>
                                    <div className="col-md-10">
                                        <input
                                            className="form-control"
                                            type="text"
                                            id="companyName"
                                            defaultValue={companyName}
                                            onChange={(e) => this.setState({companyName: e.target.value})}
                                        />
                                    </div>
                                </div>

                                {(sideBarName !== 'dealerInfo' && sideBarName !== 'adminInfo') &&
                               <div className="form-group row">
                                    <label htmlFor="example-text-input"
                                    className="col-md-2 col-form-label"></label>
                                    <div className="col-md-10 col-form-label text-left">
                                        <label>
                                            <input
                                                type="checkbox"
                                                name="isSendEmailAlertOverdue"
                                                defaultChecked={isSendEmailAlertOverdue}
                                                onChange={(e) => this.setState({ isSendEmailAlertOverdue: e.target.checked })}
                                            /> {t('ส่งemail และ แจ้งเตือนหน้าระบบเมื่อเกินกำหนด')}
                                        </label>
                                        <br />
                                        <label className="">
                                            <input
                                                type="checkbox"
                                                name="isAutoDispermit"
                                                defaultChecked={isAutoDispermit}
                                                onChange={(e) => this.setState({ isAutoDispermit: e.target.checked })}
                                            /> {t('ตัดระบบ auto')}
                                        </label>
                                    </div>
                                </div>
                                }

                                {(sideBarName === 'dealerInfo' && sideBarName !== 'adminInfo') &&
                                <div className="form-group row">
                                    <label htmlFor="example-text-input" className="col-md-2 col-form-label">Line API
                                        Token</label>
                                    <div className="col-md-10">
                                        <input
                                            className="form-control"
                                            type="text"
                                            id="lineApiToken"
                                            defaultValue={lineApiToken}
                                            onChange={(e) => this.setState({lineApiToken: e.target.value})}
                                        />
                                    </div>
                                </div>
                                }

                                {(sideBarName !== 'dealerInfo' && sideBarName !== 'adminInfo') &&
                                <div className="form-group row">
                                    <label htmlFor="example-text-input" className="col-md-2 col-form-label">Reseller
                                        note</label>
                                    <div className="col-md-10">
                                    <textarea
                                        className="form-control"
                                        id="resellerNote"
                                        rows={3}
                                        defaultValue={resellerNote}
                                        onChange={(e) => this.setState({resellerNote: e.target.value})}
                                    />
                                                    {/*<span>หากต้องการใส่หลายเบอร์ให้คั่นด้วย , (ลูกน้ำ)</span>*/}
                                    </div>
                                </div>
                                }

                                {(sideBarName === 'dealerInfo' || !isShowEdit) &&
                                <div className="form-group row">
                                    <label htmlFor="example-text-input" className="col-md-2 col-form-label"><strong>*{t('รหัสผ่าน')}</strong></label>
                                    <div className="col-md-10">
                                        <input
                                            className="form-control"
                                            type="password"
                                            id="password"
                                            onChange={(e) => this.setState({password: e.target.value})}
                                        />
                                    </div>
                                </div>
                                }

                                {(sideBarName === 'dealerInfo' || !isShowEdit) &&
                                <div className="form-group row">
                                    <label htmlFor="example-text-input" className="col-md-2 col-form-label"><strong>*{t('ยืนยันรหัสผ่าน')}</strong></label>
                                    <div className="col-md-10">
                                        <input
                                            className="form-control"
                                            type="password"
                                            id="confirm_password"
                                            onChange={(e) => this.setState({confirmPassword: e.target.value})}
                                        />
                                    </div>
                                </div>
                                }
                                { (sideBarName === 'dealerInfo') &&
                                <div className="form-group row">
                                    <label htmlFor="example-text-input"
                                    className="col-md-2 col-form-label"><strong>{t('สิทธิ์การใช้งาน')}</strong></label>
                                    <div className="col-md-10 col-form-label text-left">
                                        <label>
                                            <input
                                                type="checkbox"
                                                name="dailyReport"
                                                defaultChecked={isSendDailyReport}
                                                onChange={(e) => this.setState({ isSendDailyReport: e.target.checked })}
                                            />{t('ส่งสรุปรายงานประจำวัน')}</label>
                                            <br />
                                            <label >
                                                <input
                                                    type="checkbox"
                                                    name="subDealer"
                                                    defaultChecked={isCreateSubDealer}
                                                    onChange={(e) => this.setState({ isCreateSubDealer: e.target.checked })}
                                                />{t('สามารถสร้างผู้ขายรายย่อย')}</label>
                                    </div>
                                </div>
                                }
                                { (sideBarName === 'customerInfo') &&
                                <div className="form-group row">
                                    <label htmlFor="example-text-input"
                                    className="col-md-2 col-form-label"><strong>{t('สิทธิ์การใช้งาน')}</strong></label>
                                    <div className="col-md-10 col-form-label text-left">
                                    <label>
                                            <input
                                                type="checkbox"
                                                name="isViewTracking"
                                                defaultChecked={isViewTracking}
                                                onClick={(e) => this.setState({ isViewTracking: e.target.checked })}
                                            />{t('ดูสถานะหน้าติดตามรถ')}</label>

                                    <br />

                                        <label className="">
                                            <input
                                            type="checkbox"
                                            name="isViewPoi"
                                            defaultChecked={isViewPoi}
                                            onClick={(e) => this.setState({ isViewPoi: e.target.checked })}
                                            />{t('ดูข้อมูลPOI')}</label>

                                    <br />
                                        <label className="">
                                            <input
                                                type="checkbox"
                                                name="edit_poi"
                                                defaultChecked={isEditPoi}
                                                onClick={(e) => this.setState({ isEditPoi: e.target.checked })}
                                            />{t('แก้ไขข้อมูล POI')}</label>
                                    <br />
                                        <label className="">
                                            <input
                                                type="checkbox"
                                                name="isViewHistory"
                                                defaultChecked={isViewHistory}
                                                onClick={(e) => this.setState({ isViewHistory: e.target.checked })}
                                            />{t('ดูย้อนหลัง')}</label>
                                    <br />
                                        <label className="">
                                            <input
                                                type="checkbox"
                                                name="isSendCommand"
                                                defaultChecked={isSendCommand}
                                                onClick={(e) => this.setState({ isSendCommand: e.target.checked })}
                                            />{t('ส่งคำสั่ง')}</label>
                                    <br />
                                        <label className="">
                                            <input
                                                type="checkbox"
                                                name="isViewReport"
                                                defaultChecked={isViewReport}
                                                onClick={(e) => this.setState({ isViewReport: e.target.checked })}
                                            />{t('ดูรายงาน')}</label>
                                    </div>
                                </div>
                                }
                                <hr />
                                <div className="col-md-12 ">
                                    <div className="text-right">
                                        {
                                            userLevel <= 2 &&
                                            <button style={{ marginRight: '20px' }} type="submit" className="btn btn-primary" onClick={() => resetPassword(dataSelectRow.user_id)}>{t('เปลี่ยนรหัสผ่าน')}</button>
                                        }
                                        <button type="submit" className="btn btn-primary" onClick={this.onClickSubmit} >{t('บันทึกข้อมูล')}</button>
                                    </div>
                                </div>


                    </div>
                </div>
                <br />
                { isShowEdit &&
                    <div className="card">
                    <DeviceUserRelated
                        user_name={user_name}
                        user_id={user_id}
                        user_ids={dataSelectRow.user_id}
                        token={token}
                        history={history}
                    />
                    </div>
                }

            </div>
        );
    }
}

FormCreateNewUserByRole.defaultProps = {
    dataSelectRow: {}
    // deviceNoList: []
}

FormCreateNewUserByRole.propTypes = {
    userLevel: PropTypes.number.isRequired,
    t: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    sideBarName: PropTypes.string.isRequired,
    isShowEdit: PropTypes.bool.isRequired,
    labelName: PropTypes.string.isRequired,
    dataSelectRow: PropTypes.object,
    user_name: PropTypes.string.isRequired,
    user_id: PropTypes.number.isRequired,
    token: PropTypes.string.isRequired,
    isShowCreateNewDealer: PropTypes.bool.isRequired,
    // deviceNoList: PropTypes.array
    onBack:PropTypes.func,
    history: PropTypes.func.isRequired,
    resetPassword: PropTypes.func.isRequired
}

export default FormCreateNewUserByRole;



// WEBPACK FOOTER //
// ./src/app/view/components/AdminConfig/Content/FormCreateNewUserByRole.js